import React from 'react';
import './Widgets.css';
import { TwitterTimelineEmbed, TwitterShareButton, TwitterTweetEmbed } from "react-twitter-embed"
import { Search } from '@material-ui/icons';

function Widgets() {
    return (
        <div className='widgets'>
            <div className = 'widget_input'>
                <Search className="widgets_searchIcon"/>
                <input placeholder="Search Twitter" type="text"/>
            </div>

            <div className="widgets_widgetContainer">
                <h2>What's Happening</h2>
                <TwitterTweetEmbed tweetId={"1405044971149971458"}/>
                <TwitterTimelineEmbed
                    sourceType="profile"
                    screenName="IGN"
                    option={{height: 400}}
                />
                <TwitterShareButton
                    url={"https://twitter.com/Babahle2"}
                    options={{text: "Depression 101", via: "Babahle"}}
                />

            </div>
        </div>
    )
}

export default Widgets
